var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverspeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.048,
    height: 25.704,
    viewBox: "0 0 33.048 25.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overspeed",
    transform: "translate(-155 -210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M155.918,470.72h6.12a.986.986,0,0,1,.918.918.918.918,0,0,1-.918.918h-6.12a.986.986,0,0,1-.918-.918A.918.918,0,0,1,155.918,470.72Z",
    transform: "translate(0 -240.273)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M155.918,423.36H160.2a.986.986,0,0,1,.918.918.918.918,0,0,1-.918.918h-4.284a.986.986,0,0,1-.918-.918A.918.918,0,0,1,155.918,423.36Z",
    transform: "translate(0 -196.586)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M155.918,376h3.06a.986.986,0,0,1,.918.918.918.918,0,0,1-.918.918h-3.06a.986.986,0,0,1-.918-.918A.918.918,0,0,1,155.918,376Z",
    transform: "translate(0 -152.898)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M155.918,518.07h9.792a.986.986,0,0,1,.918.918.918.918,0,0,1-.918.918h-9.792a.986.986,0,0,1-.918-.918A.918.918,0,0,1,155.918,518.07Z",
    transform: "translate(0 -283.952)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M262.562,235.954A12.852,12.852,0,1,0,249.71,223.1,12.852,12.852,0,0,0,262.562,235.954Zm0-1.836A11.016,11.016,0,1,0,251.546,223.1,11.016,11.016,0,0,0,262.562,234.118Z",
    transform: "translate(-87.366)",
    fill: "#ff7200",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M395.576,353.933a.077.077,0,0,1-.139-.032,1.836,1.836,0,1,0-.9,1.833s0,0,0,0l-.114.2a.061.061,0,0,0,.028.086l6.891,3.136a.49.49,0,0,0,.487-.844l-6.157-4.4a.065.065,0,0,0-.095.021Z",
    transform: "translate(-218.421 -131.043)",
    fill: "#ff7200",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M405.46,258.618a.918.918,0,1,1-.918-.918.918.918,0,0,1,.918.918",
    transform: "translate(-229.346 -43.771)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M298.906,365.168a.918.918,0,1,1-.918-.918.918.918,0,0,1,.918.918",
    transform: "translate(-131.054 -142.059)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M512.016,365.078a.918.918,0,1,1-.918-.918.918.918,0,0,1,.918.918",
    transform: "translate(-327.64 -141.976)",
    fill: "#ff7200"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverspeed);
export default __webpack_public_path__ + "static/media/Overspeed.eab0a41510ca8d86da946bd9b67ffbb2.svg";
export { ForwardRef as ReactComponent };